// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { Account } from './account';
import { WarningType } from './warning-type';
import { WarningTypeEnum } from './enums';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class EntityIssue extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  // descLength is a [NotMapped] property on the server.  
  // Must be initialized to a value here to be recognized
  // TODO - demo only, remove after 2019
  descLength = 0;
  /// </code>

  // Generated code. Do not place code below this line.
  /** Int32 key */
  id!: number;
  /** Int32 FK account */
  accountId?: number;
  /** String(50) */
  applicationContext?: string;
  /** DateTimeOffset */
  crtnTs!: Date;
  /** String(4) */
  crtnUserInit!: string;
  /** String */
  description!: string;
  /** String(50) */
  entityId?: string;
  /** String(50) */
  entityTypeName?: string;
  /** Enum FK warningType */
  warningTypeId!: WarningTypeEnum;
  /** FK accountId */
  account!: Account;
  /** FK warningTypeId */
  warningType!: WarningType;
}

